module.exports = __webpack_public_path__ + "static/img/15-02.b6fc804.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/award/15-02.png
// module id = olJy
// module chunks = 1